import sendFileData from "./sendFileData";
import { getUploadUrl as getAssetUploadUrl } from "@modules/asset";
import { getUploadUrl as getResourceUploadUrl } from "@modules/resources";

const getPresignedUrlByType = async (type, file, presignedUrlParams = {}, dispatch) => {
    let response;
    switch (type) {
        case "Logo":
            response = await dispatch(getResourceUploadUrl("general", file.displayName));
            file.uploadUrl = response.uploadUrl;
            file.url = response.url;
            break;
        case "Asset":
            response = await dispatch(
                getAssetUploadUrl(presignedUrlParams.id, {
                    fileName: file.name,
                    elementId: presignedUrlParams.elementId,
                    shouldOverwrite: presignedUrlParams.shouldOverwrite,
                }),
            );
            file.uploadUrl = response?.data?.uploadUrl;
            file.url = response?.data?.url;
            break;
        default:
    }
};

const fileUpload = async ({
    file,
    stageId,
    projectId,
    cancelToken,
    onUploadProgress = () => {},
    onComplete = () => {},
    onCancel = () => {},
    onError = () => {},
    type,
    presignedUrlParams,
    dispatch,
}) => {
    if (!file) return;
    let params = {
        file,
        stageId,
        projectId,
        cancelToken,
        onUploadProgress,
        onComplete,
        onCancel,
        onError,
    };

    try {
        await getPresignedUrlByType(type, file, presignedUrlParams, dispatch);

        sendFileData(params);
    } catch (error) {
        if (error?.response?.status === 403 || ["ERR_NETWORK", "ECONNRESET", "EPIPE"].includes(error.code)) {
            fileUpload({
                file,
                stageId,
                projectId,
                cancelToken,
                onUploadProgress,
                onComplete,
                onCancel,
                onError,
                type,
                presignedUrlParams,
                dispatch,
            });
        }
    }
};

export default fileUpload;

// export const fileUploadForPreSigned = ({
//     file,
//     stageId,
//     projectId,
//     cancelToken,
//     onUploadProgress = () => {},
//     onComplete = () => {},
//     onCancel = () => {},
//     onError = () => {}}
// ) => {
//     if (!file) return;

//     let params = {
//         file,
//         stageId,
//         projectId,
//         cancelToken,
//         onUploadProgress,
//         onComplete,
//         onCancel,
//     }

//     if (window.Worker) {
//         const worker = new work(require.resolve('./getSha256Worker'));

//         worker.onmessage = (e) => {
//             params.hashedStr = e.data;

//             sendFileDataActions.sendFileDataForPreSigned(params);
//         }

//         worker.postMessage(file);
//     } else {
//         getSha256(file, undefined, params);
//     }
// };
